import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Alert, Button, Stack, TextField, Typography } from '@mui/material';

import authApi from '../../api/authApi';
import { applyServerErrors, getErrorMessage } from '../../utils/errorHandler';

const schema = yup.object({
  email: yup.string().email('Ingresa un correo válido').required('El correo es obligatorio'),
});

export default function ForgotPasswordForm() {
  const [sent, setSent] = useState(false);
  const [formError, setFormError] = useState('');

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: yupResolver(schema), defaultValues: { email: '' } });

  const onSubmit = async ({ email }) => {
    setFormError('');
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (error) {
      const handled = applyServerErrors(error, setError);
      if (!handled) {
        setFormError(getErrorMessage(error, 'No se pudo enviar el correo de recuperación.'));
      }
    }
  };

  if (sent) {
    return (
      <Alert severity="success">
        Si el correo existe en nuestro sistema, te enviamos un enlace para restablecer tu contraseña.
      </Alert>
    );
  }

  return (
    <Stack component="form" spacing={3} onSubmit={handleSubmit(onSubmit)} noValidate>
      <Typography variant="body2" color="text.secondary">
        Ingresa el correo de tu cuenta de cliente y te enviaremos un enlace para restablecer tu contraseña. Si
        eres del personal (administrador o técnico), pide a un administrador que la cambie desde Usuarios.
      </Typography>

      {formError && <Alert severity="error">{formError}</Alert>}

      <TextField
        label="Correo electrónico"
        type="email"
        error={Boolean(errors.email)}
        helperText={errors.email?.message}
        {...register('email')}
      />

      <Button type="submit" variant="contained" size="large" disabled={isSubmitting}>
        {isSubmitting ? 'Enviando...' : 'Enviar enlace'}
      </Button>
    </Stack>
  );
}
